import { Channel } from '@nemuru-eng/js-api-client';

import { Font } from '../../../../../shared/components/Font';
import { ChannelTypeIcons } from '../../constants/ChannelTypeIcons';
import { StructureCard } from './StructureCard';

interface ChannelCardProps {
  channel: Channel;
  isSelected: boolean;
  selectChannel: (index: number) => void;
  index: number;
  isMobile: boolean;
  redirectPath?: string;
}

export const ChannelCard = ({
  channel,
  isSelected,
  selectChannel,
  index,
  isMobile,
  redirectPath,
}: ChannelCardProps) => {
  return (
    <StructureCard
      key={index}
      id={channel.id}
      type={'channel'}
      isSelected={isSelected}
      onClick={() => selectChannel(index)}
      redirectPath={redirectPath}
      name={channel.description}
      username={channel.username}
      iconName={ChannelTypeIcons[channel.type]}
      copyToClipboard={{ value: channel.id, textId: 'COPY_CHANNEL_ID' }}
      isMobile={isMobile}
      endAdornment={<>{!isMobile && <Font variant={'caption'}>{channel.agents.length}</Font>}</>}
    />
  );
};
